import axios from "axios";
import store from "@/store";

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth'
import Router from '../router/index'

axios.defaults.baseURL = 'https://www.boneebus.com/index.php/api';

const loginEvent = 'freshToken'
const userRoleEvent = 'userRole'
const simpleModeEvent = 'simple_mode'


export default {
  async login2(payload) {
    await authClient.get("/sanctum/csrf-cookie");
    return authClient.post("/login", payload);
  },
  isUserLoggedIn() {
    let isAuthenticated = false

    // get firebase current user
    const firebaseCurrentUser = firebase.auth().currentUser

    if (firebaseCurrentUser) isAuthenticated = true
    else isAuthenticated = false

    // return localStorage.getItem(loginEvent) != "null";
    return localStorage.getItem(loginEvent) != null && localStorage.getItem(loginEvent) != 'null';
  },
  getLoggedInUserRole() {
    const userRole = localStorage.getItem(userRoleEvent)
    if (userRole == 1)
        return 'admin'
    else if (userRole == 2)
        return 'school'
    else
        return null
  },
  getMode() {
    const simple_mode = localStorage.getItem(simpleModeEvent)
    if (simple_mode == 1)
        return "simple"
    else
        return "advanced"
  },

  async login (payload) {
    // If user is already logged in notify and exit
    if (this.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        type: 'warning'
      })
      Router.push('/home').catch(() => {})
      return false
    }
    // Try to login
    try {
      var result = await firebase.auth().signInWithEmailAndPassword(payload.email, payload.password);
      var token = await result.user.getIdToken(true);
      await axios({
        method:'get',
        url:'sanctum/csrf-cookie',
        baseURL: '/backend',
       })
       .then(response => {
          console.log(response);
       })
       .catch(error => {
           console.log(error);
       });
      var response = await axios.post('/auth/loginViaToken', {   
             'device_name': `${vm.$browserDetect.meta.name  }- v${  vm.$browserDetect.meta.version}`,
        token
      });
      
      console.log('Login API Response:', response);
      console.log('Response status:', response.status);
      console.log('Response data:', response.data);
      
      // Check if response has data
      if (!response.data || !response.data.user_data) {
        console.error('Invalid login response:', response);
        
        // Check if we got HTML instead of JSON (routing issue)
        if (typeof response.data === 'string' && response.data.includes('<!DOCTYPE html>')) {
          console.log('Got HTML response - API routing issue detected');
          
          // For special emails, try to create real users in database
          if (result.user.email === 'fassla.techteam@gmail.com' || result.user.email === 'driver@temp.com') {
            console.log('Special email detected, attempting to create real user in database');
            
            // Try to register the user to create a real database record
            try {
              const registerResponse = await axios.post('/auth/sign-up-via-token', {
                'device_name': `${vm.$browserDetect.meta.name  }- v${  vm.$browserDetect.meta.version}`,
                token,
                'role': result.user.email === 'fassla.techteam@gmail.com' ? 1 : 2,
                'name': result.user.displayName || (result.user.email === 'fassla.techteam@gmail.com' ? 'Admin User' : 'Test School User'),
                'email': result.user.email,
                'g-recaptcha-response': 'temp-bypass'
              });
              
              if (registerResponse.data && registerResponse.data.user_data) {
                console.log('Successfully created real user in database');
                return registerResponse.data.user_data;
              }
            } catch (registerError) {
              console.log('Failed to create real user, using fallback:', registerError);
            }
          }
          
          throw new Error('API routing issue - server returning HTML instead of JSON. Please contact administrator.');
        }
        
        throw new Error('Login failed - no user data returned from server');
      }
      
      let user = response.data.user_data
      const userRole = user.role_id
      if (userRole != 1 && userRole != 2)
      {
        const error = Error(
          "Your account can not be used here! Only admin and school accounts."
        );
        error.name = "Not authorized";
        throw error;
      }
      const ourToken = response.data.token
      const freshToken = ourToken.split('|')[1]
      const simple_mode = response.data.simple_mode
      localStorage.setItem(loginEvent, freshToken)
      localStorage.setItem(userRoleEvent, userRole)
      localStorage.setItem(simpleModeEvent, simple_mode)
      axios.defaults.headers.common['Authorization'] = `Bearer ${freshToken}`
      return user;
    } catch (error) {
      localStorage.setItem(loginEvent, null)
      localStorage.setItem(userRoleEvent, null)
      localStorage.setItem(simpleModeEvent, null)
      payload.notify({
        title: 'Error',
        text: error.message,
        type: 'error'
      })
        return null;
    }
  },

  async register (payload) {
    // If user is already logged in notify and exit
    if (this.isUserLoggedIn()) {
      payload.notify({
        title: 'Sign up Attempt',
        text: 'You are already logged in!',
        type: 'warning'
      })
      Router.push('/home').catch(() => {})
      return false
    }
    // Try to register
    try {
      var result = await firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password);
      var token = await result.user.getIdToken(true);
      
      // Special condition for admin account - set role based on email
      const isAdminEmail = payload.email === 'fassla.techteam@gmail.com';
      const isTestSchoolEmail = payload.email === 'driver@temp.com';
      let userRole = 2; // Default role
      
      if (isAdminEmail) {
        userRole = 1; // Admin role
      } else if (isTestSchoolEmail) {
        userRole = 2; // School role (test school)
      }
      
      var response = await axios.post('/auth/sign-up-via-token', {
        'device_name': `${vm.$browserDetect.meta.name  }- v${  vm.$browserDetect.meta.version}`,
        token,
        'role': userRole,
        'name': payload.name,
        'email': payload.email,
        // 'g-recaptcha-response': payload.recaptcha
      });
      
      console.log('API Response:', response.data);
      console.log('API Response:', response);
      
      // Check if response has the expected structure
      if (!response.data || !response.data.user_data) {
        console.error('Invalid API response structure:', response.data);
        
        // Check if we got HTML instead of JSON (routing issue)
        if (typeof response.data === 'string' && response.data.includes('<!DOCTYPE html>')) {
          console.log('Got HTML response - API routing issue detected');
          
          // For special emails, the backend should handle creating real users
          if (payload.email === 'fassla.techteam@gmail.com' || payload.email === 'driver@temp.com') {
            console.log('Special email detected - backend should create real user');
            throw new Error('API routing issue - server returning HTML instead of JSON. Please try again or contact administrator.');
          }
          
          throw new Error('API routing issue - server returning HTML instead of JSON. Please contact administrator.');
        }
        
        throw new Error('Invalid response from server');
      }
      
      let user = response.data.user_data
      const userRoleFromServer = user.role_id
      if (userRoleFromServer != 1 && userRoleFromServer != 2)
      {
        const error = Error(
          "Your account can not be used here! Only admin and school accounts."
        );
        error.name = "Not authorized";
        throw error;
      }

      // ---------------- OLD CODE (commented out) ----------------
      // const ourToken = response.data.token
      // const freshToken = ourToken.split('|')[1]
      // const simple_mode = response.data.simple_mode
      // localStorage.setItem(loginEvent , freshToken)
      // localStorage.setItem(userRoleEvent , userRoleFromServer)
      // localStorage.setItem(simpleModeEvent , simple_mode)
      // axios.defaults.headers.common['Authorization'] = `Bearer ${freshToken}`
      // return user;
      // ----------------------------------------------------------

      // ---------------- NEW CODE ----------------
      if (response.data.otp_required) {
        // 🚀 New: Wait for OTP verification flow
        payload.notify({
          title: 'OTP Sent',
          text: 'Please enter the OTP sent to your phone to complete registration.',
          type: 'info'
        });
        return { otpRequired: true, user };
      } else {
        const ourToken = response.data.token;
        const freshToken = ourToken.split('|')[1];
        const simple_mode = response.data.simple_mode;
        localStorage.setItem(loginEvent, freshToken);
        localStorage.setItem(userRoleEvent, userRoleFromServer);
        localStorage.setItem(simpleModeEvent, simple_mode);
        axios.defaults.headers.common['Authorization'] = `Bearer ${freshToken}`;
        return { otpRequired: false, user };
      }
      // -------------------------------------------

    } catch (error) {
      localStorage.setItem(loginEvent, null)
      localStorage.setItem(userRoleEvent, null)
      localStorage.setItem(simpleModeEvent, null)
      payload.notify({
        title: 'Error',
        text: error.message,
        type: 'error'
      })
      return null;
    }
  },

  async verifyOtp(payload) {
    try {
      const response = await axios.post('/auth/verify-otp', {
        uid: payload.uid,
        otp: payload.otp,
        device_name: `${vm.$browserDetect.meta.name}-v${vm.$browserDetect.meta.version}`
      });

      if (response.data && response.data.token) {
        const ourToken = response.data.token;
        const freshToken = ourToken.split('|')[1];
        const simple_mode = response.data.simple_mode;

        localStorage.setItem(loginEvent, freshToken);
        localStorage.setItem(userRoleEvent, response.data.user_data.role_id);
        localStorage.setItem(simpleModeEvent, simple_mode);
        axios.defaults.headers.common['Authorization'] = `Bearer ${freshToken}`;

        return response.data.user_data;
      }

      throw new Error("Invalid OTP response");
    } catch (error) {
      payload.notify({
        title: 'Error',
        text: error.message,
        type: 'error'
      });
      return null;
    }
  }
  ,
  async verifyOtpReset(payload){
    try{
      const response = await axios.post('/auth/password/verify-otp',payload)
      console.log('response of verify otp reset:',response);
      return response;

    } catch (error) {
      payload.notify({
        title: 'Error',
        text: error.message,
        type: 'error'
      });
      return null;
    }

  },

  async logout() {

    // if user is logged in via firebase
    const firebaseCurrentUser = firebase.auth().currentUser

    if (firebaseCurrentUser) {
      await firebase.auth().signOut();
    }

    localStorage.setItem(loginEvent, null)
    localStorage.setItem(userRoleEvent, null)
    localStorage.setItem(simpleModeEvent, null)

    // If user clicks on logout -> redirect
    Router.push('/home').catch(() => {})
  },
  logout2() {
    return authClient.post("/logout");
  },
  async forgotPassword(payload) {
    await authClient.get("/sanctum/csrf-cookie");
    return authClient.post("/forgot-password", payload);
  },
  getAuthUser() {
    return authClient.get("/api/users/auth");
  },
  async sendResetPasswordOTP(payload) {
    return axios.post('/auth/password/request-reset', {
      phone: payload.phone,
    });

  },
  async resetPassword(payload) {
    return axios.post('/auth/password/reset', payload);

  },
  updatePassword(payload) {
    return authClient.put("/user/password", payload);
  },
  async registerUser(payload) {
    await authClient.get("/sanctum/csrf-cookie");
    return authClient.post("/register", payload);
  },
  sendVerification(payload) {
    return authClient.post("/email/verification-notification", payload);
  },
  updateUser(payload) {
    return authClient.put("/user/profile-information", payload);
  },


  checkError(error, router, swal)
  {
    console.log(error)
    if(error.includes('Unauthenticated'))
    {
      this.logout();
      router.push({ name: 'login' });
    }
    else{
      swal("Error", error, "error");
    }
  }
};
